<script setup>
import {ref, computed, reactive, onMounted, watch} from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import {XMarkIcon, ChevronRightIcon, ChevronLeftIcon, FireIcon, CheckIcon,
        EyeIcon} from '@heroicons/vue/24/solid'
import { useRoute, useRouter } from 'vue-router'

import {useMessageStore } from '@/stores/messagestore.js'
const messageStore = useMessageStore();

import {useUserStore } from '@/stores/userstore.js'
const userStore = useUserStore();

import ButtonLoad from "./ButtonLoad.vue"
import MarkdownRenderer from './MarkdownRenderer.vue'
import Popup from "./Popup.vue"
import Tooltip from "./Tooltip.vue"

const app_server = import.meta.env.VITE_APP_SERVER;

const router = useRouter();

function sleep(n) { return new Promise(resolve=>setTimeout(resolve,n)); }

const props = defineProps({
    show: false,
});

const extra_data = reactive({
    show: false,
    index: 0,
    current_notification: null,
    notifications: [],
});

function get_notification(){
    if(extra_data.notifications[0] == null ){
        return {};
    }
    if(extra_data.index < 0){
        extra_data.index = extra_data.notifications.length - 1;
    }else if(extra_data.index >= extra_data.notifications.length){
        extra_data.index = 0;
    }
    return extra_data.notifications[extra_data.index];    
}

function closed_popup(){
    extra_data.show = false;
    if(extra_data.current_notification != null){
    }else{
        console.log("NO CURRENT");
    }
}

const seen_notifications = [];
function has_seen(notification_id){
    if(props.in_admin || notification_id == null){
        return false;
    }
    if(seen_notifications.length == 0){
        seen_notifications.push(...JSON.parse(localStorage.getItem("releasenotifications:seen") || "[null]"));
    }
    console.log(seen_notifications);
    return seen_notifications.includes(notification_id);
}

async function set_seen(notification){
    messageStore.set_read(notification);
    notification.seen = true;
}

async function get_notifications(){
    const notifications = await messageStore.get_notifications();
    
    extra_data.notifications = notifications;
}

async function signal(notification_id, action){
    var url = app_server + `/releasenotification/${notification_id}/signal/`;

    const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers:{
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("jwt"),
        },
        body: JSON.stringify({
            "action": action,
        }),
    });

    const data = await response.json();
    
    if(data.status == "success"){
        console.log("signalled server", notification_id, action);
    }
}

function do_notification_action(page){
    if(extra_data.current_notification != null){
        const notification_id = extra_data.current_notification.notification_id;
        signal(notification_id, "click");
        set_seen(notification_id);
    }
    if(page.action_url.startsWith("http")){
        if(confirm("You are leaving OpenGammon.com, are you sure?")){
            window.location.href = page.action_url;
        }else{
            return;
        }
    }else{
        router.push(page.action_url);
    }
    extra_data.show = false;
}

watch(() => props.notifications, (x, y) => {
    extra_data.notifications = props.notifications;
});

watch(() => props.show, (x, y) => {
    extra_data.show = props.show;
});


onMounted(() => {
    if(props.notifications == null){
        extra_data.notifications = {};
    }    
    if(props.show == null){
        extra_data.show = false;
    }else{
        extra_data.show = props.show;
    }

    get_notifications();
});

// 
</script>
<template>
    <Popup :show="extra_data.show"
        @close="closed_popup()"
    >
    <div class="h-[90svh] overflow-y-auto flex flex-col gap-y-8">
        <h1 class="text-4xl mt-8">
            Notifications Centre
        </h1>
        
        <div class="flex flex-col gap-y-4"
             v-for="notification in extra_data.notifications"
        >
            <div class="box min-h-32 py-3 px-6 rounded-lg"
                 :class="{
                    'bg-accent-1-color': !notification.seen,
                    'bg-main-2-color': notification.seen,
                }"
            >
                <div class="text-xl flex justify-between">
                    <h2>
                        {{ notification.title }}
                    </h2>
                    <Tooltip 
                        text="Unseen notification, click to set to seen."
                        direction="left"
                    >
                        <EyeIcon 
                            class="size-6 text-accent-3-color cursor-pointer"
                            @click="set_seen(notification)"
                            v-if="!notification.seen"
                        />
                    </Tooltip>
                </div>
                <span class="text-sm font-light">
                    {{ new Date(notification.time * 1000).toLocaleString() }}
                </span>
                <div class="mt-4">
                    <MarkdownRenderer :markdown="notification.text" />
                </div>

            </div>
        </div>

    </div>
    </Popup>     
</template>

<style scoped>
</style>



